namespace TotalPoll {
    import SettingsService = TotalCore.Common.Providers.SettingsService;
    import Controller = TotalCore.Common.Controller;

    @Controller('controllers.totalpoll')
    export class SidebarIntegrationCtrl {
        public sidebar;

        constructor(private ajaxEndpoint, private SettingsService: SettingsService) {
        }

        addWidgetToSidebar() {
            this.sidebar.inserted = true;

            jQuery
                .post(
                    this.ajaxEndpoint,
                    {
                        action: 'totalpoll_polls_add_to_sidebar',
                        poll: this.SettingsService.settings.id,
                        sidebar: this.sidebar.id
                    }
                )
                .then((response) => this.sidebar.inserted = response.success || false)
                .fail(() => this.sidebar.inserted = false);
        }
    }

}